import {wallet} from '@cityofzion/neon-core'
import BigNumber from 'bignumber.js'
import {NeonInvoker} from '@cityofzion/neon-invoker'
import {EnvHelper} from '@/helpers/EnvHelper'
import {RpcHelper} from '@/helpers/RpcHelper'

type TGetAmountsOutFlamingoArgs = {
  amountIn: string
  decimalsTokenToUse?: number
  hashTokenToUse: string
  hashTokenToReceive: string
}

export class GleederHelper {
  static neonInvoker: NeonInvoker | null = null
  private static neonInvokerRpc: string | null = null
  static readonly flamingoSwapRouterScriptHash =
    EnvHelper.VUE_APP_FLAMINGO_ROUTER_SCRIPT_HASH
  static readonly gasScriptHash = EnvHelper.VUE_APP_GAS_SCRIPT_HASH

  static async getNeonInvoker(): Promise<NeonInvoker> {
    const rpcAddress = await RpcHelper.getActiveRpc()

    if (!this.neonInvoker || this.neonInvokerRpc !== rpcAddress) {
      this.neonInvoker = await NeonInvoker.init({
        rpcAddress,
        account: new wallet.Account(),
      })
      this.neonInvokerRpc = rpcAddress
    }

    return this.neonInvoker
  }

  static async getAmountsOutFlamingo({
    amountIn,
    decimalsTokenToUse = 0,
    hashTokenToUse,
    hashTokenToReceive,
  }: TGetAmountsOutFlamingoArgs) {
    const fixedAmount = BigNumber(amountIn)
      .shiftedBy(decimalsTokenToUse)
      .toString()
    const neonInvoker = await this.getNeonInvoker()
    return neonInvoker.testInvoke({
      invocations: [
        {
          operation: 'getAmountsOut',
          scriptHash: this.flamingoSwapRouterScriptHash,
          args: [
            {type: 'Integer', value: fixedAmount},
            {
              type: 'Array',
              value: [
                {
                  type: 'Hash160',
                  value: hashTokenToUse,
                },
                {
                  type: 'Hash160',
                  value: hashTokenToReceive,
                },
              ],
            },
          ],
        },
      ],
    })
  }
}
